<template>
  <van-dialog
    v-model:show="dialogShow"
    :before-close="confirm"
    show-cancel-button
    title="实名认证"
  >
    <van-field
      v-model="form.username"
      input-align="right"
      is-link
      label="姓名"
      label-class="new-cell"
      name="phone"
      placeholder="请填写姓名"
      required
      size="large"
    />
    <van-field
      v-model="form.id"
      input-align="right"
      is-link
      label="身份证号"
      label-class="new-cell"
      name="wechat"
      placeholder="请填写身份证号码"
      required
      size="large"
      maxlength="20"
      @update:model-value="inputChanage"
    />
    <van-field
      v-model="form.phone"
      input-align="right"
      is-link
      label="联系方式"
      label-class="new-cell"
      name="wechat"
      placeholder="请填写手机/电话"
      required
      size="large"
    />
  </van-dialog>
</template>
<script>
import { Toast } from "vant";
export default {
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      form: {
        username: "",
        id: "",
        phone: "",
      },
      dialogShow: false,
    };
  },
  methods: {
    inputChanage(value) {
      this.form.id = value.replace(/\s+/g, "");
    },
    show() {
      this.dialogShow = true;
    },
    confirm(action) {
      return new Promise((resolve) => {
        if (action === "confirm") {
          if (!/[^\d\r\n]{2,30}$/.test(this.form.username)) {
            resolve(false);
            Toast("姓名请输入2-30个中文/字母/特殊符号");
            return;
          }
          if (!this.form.id) {
            resolve(false);
            Toast("请输入证件号");
            return;
          }
          if (!/^[\d\+\-\(\)\s]{5,30}$/.test(this.form.phone.trim())) {
            resolve(false);
            Toast("请输入正确的联系方式！");
            return;
          }
          this.data.id = this.form.id;
          this.data.phone = this.form.phone;
          this.data.username = this.form.username;
          resolve(true);
        } else {
          resolve(true);
        }
      });
    },
  },
};
</script>
